import {Component, EventEmitter, OnDestroy, OnInit} from '@angular/core';
import {ContactService as ApiContactService} from '../../api/services/contact.service';
import {TagModel} from '../../api/models/tag-model';
import {TagsService as ApiTagsService} from '../../api/services/tags.service';
import {FilterOptionModel} from '../grid-filter/filter-option.model';
import {RolesEnum} from '../../core/security/roles.enum';
import {ModulesEnum} from '../../core/security/modules.enum';
import {AuthService} from '../../core/security/auth.service';
import { MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { FlexModule } from '@angular/flex-layout';
import { GridFilterComponent } from '../grid-filter/grid-filter.component';
import { ContactsDialogGridComponent } from './contacts-dialog-grid.component';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-contacts-dialog',
    templateUrl: './contacts-dialog.component.html',
    styleUrls: ['./contacts-dialog.component.scss'],
    standalone: true,
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, FlexModule, GridFilterComponent, ContactsDialogGridComponent, MatDialogActions, MatButton, MatDialogClose]
})
export class ContactsDialogComponent implements OnInit, OnDestroy {

  filterChangeEvent = new EventEmitter<void>();
  filterOptions: FilterOptionModel[] = [];

  tags: TagModel[];

  constructor(public dialogRef: MatDialogRef<ContactsDialogComponent>,
              private apiContactService: ApiContactService,
              private apiTagsService: ApiTagsService,
              private authService: AuthService) {

  }

  ngOnInit() {
    const hasTagsViewAccess = this.authService.hasAccess([RolesEnum.Tags_View, RolesEnum.Tags_Edit, RolesEnum.Tags_Delete])
      && this.authService.userHasPackage(ModulesEnum.TagsModule);

    if (hasTagsViewAccess) {
      this.getTags().then((tags) => {
        this.tags = tags;
        this.initFilterOptions();
      });
    } else {
      this.initFilterOptions();
    }
  }

  ngOnDestroy() {
  }

  public async getTags(): Promise<TagModel[]> {
    const response = await this.apiTagsService.tagsGetTags().toPromise();
    this.tags = response;

    return response;
  }

  selectContact(selection: any) {
    this.dialogRef.close(selection.selected[0].phoneNumber);
  }

  onFilterChanged(filter: any) {
    this.filterChangeEvent.emit(filter);
  }

  initFilterOptions(): void {
    this.filterOptions = [
      {
        filterKey: 'searchText',
        multiValue: false,
        showAlways: true,
        type: 'string',
        title: 'Any'
      },
      {
        filterKey: 'phoneNumber',
        multiValue: false,
        showAlways: true,
        title: 'Phone Number',
        type: 'phoneNumber',
      },
      {
        filterKey: 'contactType',
        multiValue: false,
        showAlways: false,
        type: 'static',
        title: 'Directory',
        displayValue: 'Company',
        value: '0',
        searchText: 'Directory: Company',
      },
      {
        filterKey: 'contactType',
        multiValue: false,
        showAlways: false,
        type: 'static',
        title: 'Directory',
        displayValue: 'Private',
        value: '1',
        searchText: 'Directory: Private',
      },
      {
        filterKey: 'type',
        multiValue: false,
        showAlways: false,
        type: 'static',
        title: 'Type',
        displayValue: 'Primary',
        value: 'Primary',
        searchText: 'Type: Primary',
      },
      {
        filterKey: 'type',
        multiValue: false,
        showAlways: false,
        type: 'static',
        title: 'Type',
        displayValue: 'Mobile',
        value: 'Mobile',
        searchText: 'Type: Mobile',
      },
      {
        filterKey: 'type',
        multiValue: false,
        showAlways: false,
        type: 'static',
        title: 'Type',
        displayValue: 'Fax',
        value: 'Fax',
        searchText: 'Type: Fax',
      },
    ];

    if (this.tags?.length > 0) {
      for (const tag of this.tags) {
        this.filterOptions.push({
          filterKey: 'tags',
          multiValue: true,
          showAlways: false,
          type: 'static',
          title: 'Tag',
          displayValue: tag.name,
          value: tag.id,
          searchText: `Tag: ${tag.name}`,
        });
      }
    }
  }
}
